import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import {
  CONTACTS_ENDPOINTS,
} from '../api/api-endpoints';
import { RestApiService } from '../api/rest-api.service';

export interface UnifiedContact {
  contact_id: string;
  source_type: string;
  display_name: string;
  email: string | null;
  phone: string | null;
  organisation_id: string | null;
  account_id: string | null;
  account_name: string | null;
  user_id: string | null;
  crm_contact_id: string | null;
  messaging_identity: string;
  contact_role: string;
  created_at: string | null;
  updated_at: string | null;
}

export interface ContactDirectoryResponse {
  contacts: UnifiedContact[];
  total: number;
  users_total: number;
  crm_total: number;
  partners_total: number;
  account_summaries: Array<{
    account_id: string;
    account_name: string;
    contacts_count: number;
    contact_ids: string[];
  }>;
}

@Injectable({
  providedIn: 'root',
})
export class ContactsDirectoryService {
  constructor(private readonly api: RestApiService) {}

  async getDirectory(search?: string): Promise<ContactDirectoryResponse> {
    const query = new URLSearchParams();
    if (search && search.trim()) {
      query.set('search', search.trim());
    }

    const endpoint = query.toString()
      ? `${CONTACTS_ENDPOINTS.directory}?${query.toString()}`
      : CONTACTS_ENDPOINTS.directory;

    return firstValueFrom(this.api.get<ContactDirectoryResponse>(endpoint));
  }

  async resolveByMessagingIdentity(identity: string): Promise<UnifiedContact> {
    const endpoint = CONTACTS_ENDPOINTS.messaging_identity.replace('{0}', encodeURIComponent(identity));
    return firstValueFrom(this.api.get<UnifiedContact>(endpoint));
  }

  async getStats(): Promise<{ total: number; users_total: number; crm_total: number; partners_total: number; accounts_total: number }> {
    return firstValueFrom(this.api.get(CONTACTS_ENDPOINTS.stats));
  }
}
